export default __webpack_public_path__ + "static/media/image2-4.39d2dc31.png";